function createMessagePreview(branchName, content, phoneNumber, requestCallBack) {
    const body = [];
    const footer = [];

    if (branchName && branchName !== 'false') {
        body.push(`${branchName}: `);
    }

    body.push(`${content} `);

    if (requestCallBack) {
        footer.push('Please call the pharmacy');
    } else {
        footer.push('Questions? Call');
    }

    if (phoneNumber && phoneNumber !== 'false') {
        footer.push(` ${phoneNumber}`);
    }

    footer.push('. Unmonitored number. Text END to opt out.');

    return {
        body: body.join('').trim(),
        footer: footer.join('').trim(),
    };
}

export default createMessagePreview;
